import React, { useEffect, useState } from 'react'
import styles from './styles'
import { withStyles, Typography } from '@material-ui/core'
import TeamsMemberListContainer from 'src/container/teams-member-list'
import { TeamsMemberListHeader } from './components'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
const TeamsMemberList = props => {
  const { classes } = props
  const { id } = useParams()
  const collection = useSelector(state => state.collection.collection)
  const collectionSettings = useSelector(
    state => state.collection.collectionSettings,
  )
  const [key, setKey] = useState(0)

  const teamsId = collectionSettings?.teams?.find(team => team.default === true)
    ?.id

  useEffect(() => {
    setKey(prevKey => prevKey + 1)
  }, [teamsId])

  if (collectionSettings === undefined) {
    return <div>Loading...</div>
  }
  const learnerAccess = collectionSettings.accessRule

  if (learnerAccess === 0) {
    return (
      <div className={classes.learnerAccessContainer}>
        <img
          src="/assets/team-learneraccess.png"
          alt="team-learneraccess"
          className={classes.teamLearnerAccessImage}
        />
        <Typography fontSize="16px" fontWeight={500}>
          Learners’ Access Type:
          <span className={classes.learnerAccessType}> Public</span>
        </Typography>
        <Typography
          color="#838D98"
          fontSize="14px"
          fontWeight={400}
          className={classes.learnerAccessDescription}
        >
          There is no Learners list because anyone with the link can join your
          collection. You can access analytics rate reports.
        </Typography>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      {learnerAccess === 2 && <TeamsMemberListHeader />}
      <div className={classes.teamListRoot}>
        <TeamsMemberListContainer key={key} id={id} teamsId={teamsId} />
      </div>
    </div>
  )
}

export default withStyles(styles)(TeamsMemberList)
